import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Badge } from '@mui/material';
import { Row, Col } from 'react-bootstrap';
import { ChatLeftTextFill, PersonPlusFill, ShieldCheck } from 'react-bootstrap-icons';
import { getNotifications } from '../../app/selector';

const News = () => {
  const { messages, confirms, requests } = useSelector(getNotifications);
  const navigate = useNavigate();

  const badgeStyle = {
    '& .MuiBadge-badge': {
      fontSize: { xs: 11, sm: 16 },
      height: { xs: 22, sm: 30 },
      width: { xs: 22, sm: 30 },
      minWidth: { xs: 22, sm: 30 },
      borderRadius: '50%',
      fontWeight: 'bold',
      border: '2px solid white',
    },
  };

  return (
    <div className="content-block bg-light p-3 rounded">
      {/* Reverted back to your original title class */}
      <h1 className="text-center menu-title">News</h1>

      <Row className="mb-4">
        <Col xs={6} className="text-center">
          <button
            className="newsButton"
            onClick={() => navigate('/inbox')}
          >
            <Badge badgeContent={messages} color="error" overlap="circular" sx={badgeStyle}>
              <ChatLeftTextFill className="newsIcon text-primary" />
            </Badge>
          </button>
          <div className="label">Chat</div>
        </Col>

        <Col xs={6} className="text-center">
          <button
            className="newsButton"
            onClick={() => navigate('/requests')}
          >
            <Badge badgeContent={requests} color="error" overlap="circular" sx={badgeStyle}>
              <PersonPlusFill className="newsIcon text-warning" />
            </Badge>
          </button>
          <div className="label">Requests</div>
        </Col>
      </Row>

      <Row>
        <Col xs={6} className="text-center">
          <button
            className="newsButton"
            onClick={() => navigate('/accepted-requests')}
          >
            <Badge badgeContent={confirms} color="error" overlap="circular" sx={badgeStyle}>
              <ShieldCheck className="newsIcon text-success" />
            </Badge>
          </button>
          <div className="label">Confirms</div>
        </Col>
        <Col xs={6} />
      </Row>
    </div>
  );
};

export default News;